module.exports = __webpack_public_path__ + "cc61d24e5fa2efaa302e8c732fe3151a.MP3";